const state = {
	optYear: {
		list: '',
		selected: '',
	},
};

const getters = {
	optYear: state => state.optYear,
};

const mutations = {
	optYearOfList(state, list) {
		state.optYear.list = list;
		// state.optYear.list.unshift(yearLimit - year);
	},
	optYearOfSelected(state, data) {
		state.optYear.selected = data;
	},
};

const actions = {
	generateOptYear({commit}, period) {
		// 今年
		const year = new Date().getFullYear();
		let list   = [];
		for (let i = 0; i < period; i++) {
			list.unshift(year - i);
		}
		commit('optYearOfList', list);
		commit('optYearOfSelected', list[list.length * 0.6]);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}